import type React from "react";
import type {ReactNode} from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

type Props = {
    /** Shows a "Dashboards" back link above the dashboard. Left out while Atlas is docked: its close button is the way back. */
    onBack?: () => void;
    children: ReactNode;
};

/** The page panel's dashboard view, in the gallery (a dashboard Atlas just built) and on the dashboard page. */
export const DashboardDetailLayout: React.FC<Props> = ({onBack, children}) => (
    <div className="dsh-root dsh-detail">
        {onBack && (
            <div className="dsh-detail-bar">
                <button type="button" className="dsh-back" onClick={onBack}>
                    <ArrowBackIcon sx={{fontSize: 16}}/> Dashboards
                </button>
            </div>
        )}
        <div className="dsh-detail-body">{children}</div>
    </div>
);
